import { enhancedRequest, ragRequest, ragStreamRequest } from '../utils/request.js'

// AI服务认证
const aiAuth = () => enhancedRequest({
  url: `/api/v1/user/auth/ai/auth`,
  method: 'get'
})

// 英语单词-获取模板列表（支持传入自定义 token）
// GET /api/v1/ai/english/word/chat/prompt
// 返回：data 为 Map<String, String>
const getPromptList = (token = null) => ragRequest({
  url: `/api/v1/ai/english/word/chat/prompt`,
  method: 'get',
  token: token // 传入自定义 token（aiToken）
})

// 英语单词-获取快捷回复列表（支持传入自定义 token）
// GET /api/v1/ai/english/word/chat/quick/reply/{wordId}
// 返回：data 为 Array<{ context: string }>
const getQuickReplyList = (wordId, token = null) => ragRequest({
  url: `/api/v1/ai/english/word/chat/quick/reply`,
  method: 'get',
  token: token // 传入自定义 token（aiToken）
})

// 英语单词-创建一个对话（支持传入自定义 token）
// POST /api/v1/ai/english/word/chat/new
// body: { modelType, promptId, message, nickname, grade, word }
const createWordChat = (data = {}, token = null) => ragRequest({
  url: `/api/v1/ai/english/word/chat/new`,
  method: 'post',
  data,
  token: token // 传入自定义 token（aiToken）
})

// 英语单词-发送消息（支持传入自定义 token）
// POST /api/v1/ai/english/word/chat/completions
// body: { chatRecordId, message, imageUrl, ext, nickname, grade }
const sendWordChatCompletions = (data = {}, token = null) => ragRequest({
  url: `/api/v1/ai/english/word/chat/completions`,
  method: 'post',
  data,
  token: token // 传入自定义 token（aiToken）
})

// 英语单词-发送消息（流式）（支持传入自定义 token）
// POST /api/v1/ai/english/word/chat/completions
const sendWordChatCompletionsStream = (data = {}, onMessage, token = null) => ragStreamRequest({
  url: `/api/v1/ai/english/word/chat/completions`,
  method: 'post',
  data,
  token: token // 传入自定义 token（aiToken）
}, onMessage)

// 语音转文本（支持传入自定义 token）
const mp3ToText = (data = {}, token = null, extraOptions = {}) => ragRequest({
  url: `/api/v1/ai/english/word/sis/mp3ToText`,
  method: 'post',
  data,
  token: token, // 传入自定义 token（aiToken）
  ...extraOptions
})

// 英语单词-关闭对话（支持传入自定义 token）
// DELETE /api/v1/ai/english/word/chat/{chatRecordId}
// Path 参数: chatRecordId (必需)
// Header 参数: X-Authorization-Token (可选，通过 token 参数传入)
const stopWordChatCompletions = (chatRecordId, token = null) => ragRequest({
  url: `/api/v1/ai/english/word/chat/${chatRecordId}`,
  method: 'delete',
  data: {}, // 不需要 body 参数
  token: token // 传入自定义 token（aiToken），会自动设置到 X-Authorization-Token header
})

// 口语评测-根据文本转语音（调试用）
// POST /api/v1/ai/english/spoken/resultByTextToTTs
// body: { prompt, reportId }
const resultByTextToTTs = (data = {}, token = null) => ragRequest({
  url: `/api/v1/ai/english/spoken/resultByTextToTTs`,
  method: 'post',
  data,
  token: token // 传入自定义 token（aiToken）
})

// 口语评测-关闭对话音频通话（调试用）
// DELETE /api/v1/ai/english/spoken/audioClose/{recordId}
// Path 参数: recordId (必需)
// Header 参数: X-Authorization-Token (可选，通过 token 参数传入)
const audioClose = (recordId, token = null) => ragRequest({
  url: `/api/v1/ai/english/spoken/audioClose/${recordId}`,
  method: 'delete',
  data: {}, // 不需要 body 参数
  token: token // 传入自定义 token（aiToken），会自动设置到 X-Authorization-Token header
})

const historyList = () => ragRequest({
  url:`/api/v1/ai/english/spoken/chat/page`
})
export {
  aiAuth,
  getPromptList,
  getQuickReplyList,
  createWordChat,
  sendWordChatCompletions,
  sendWordChatCompletionsStream,
  mp3ToText,
  stopWordChatCompletions,
  resultByTextToTTs,
  audioClose,
  historyList
}
